// extracted by mini-css-extract-plugin
export default {"container":"user-chat-message_container__iThqx","message":"user-chat-message_message__CtlX6"};